export const GET_TRADING_DATA = 'api/Trading/GetTradingData';
export const SET_TRADING_DATA = 'api/Trading/SetTradingData';
export const DELETE_TRADING_DATA = 'api/Trading/DeleteTradingData';
export const DOWNLOAD_TRADING_DATA = '/api/Trading/Download';

export const GET_NBP_TRADE_DATA = '/api/NBPTrade';
export const DOWNLOAD_NBP_TRADE_DATA = '/api/NBPTrade/Download';

export const MESSAGES = {
  REQUIRED_QUANTITY: 'Quantity is required',
  REQUIRED_START_DATE: 'Start Date is required',
  REQUIRED_END_DATE: 'End Date is required',
  REQUIRED_TRADE_DATE: 'Trade Date is required',
  REQUIRED_LOCATION: 'Location is required',
  REQUIRED_COUNTERPARTY: 'Counterparty is required',
};
